module.exports = __webpack_public_path__ + "media/images/home/logo-clutter-endorser-white-d86fa67aa4e81ee601197e18c442d28c.png";